// Extra classes for a dropdown filter trigger (`Button variant="secondary" size="sm"`) while its
// filter is active. The DS tint and ink (`--tag` on `--primary-ink`) reads as stronger than the
// grey `secondary` fill in every accent and theme, and the hover/open overrides stop
// `secondary`'s own darker hover fill from sitting under the ink. Never `bg-accent`, which is a
// paler grey than `secondary` and leaves dark text on a darkened hover.
export const ACTIVE_FILTER_TRIGGER =
  'border-primary-ink bg-tag text-primary-ink hover:bg-tag aria-expanded:bg-tag aria-expanded:text-primary-ink';
